import React from 'react';
import { Helmet } from 'react-helmet';

const Disclosures: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Terms & Disclosures - Professional ASWB Exam Prep | Social Work Test Prep Academy</title>
        <meta name="description" content="📜 Professional terms of service and disclosures for AI-powered ASWB exam preparation. Understand content guidelines, user responsibilities, and platform terms for your licensing success." />
        <meta property="og:title" content="Terms & Disclosures - Professional ASWB Exam Prep Platform" />
        <meta property="og:description" content="📜 Professional terms and disclosures for AI-powered ASWB exam preparation. Clear guidelines for platform usage and content standards." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.socialworktestprepacademy.com/disclosures" />
        <meta property="og:image" content="https://www.socialworktestprepacademy.com/images/default-og-image.png" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:site_name" content="Social Work Test Prep Academy" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Terms & Disclosures - Professional ASWB Prep" />
        <meta name="twitter:description" content="📜 Professional terms for AI-powered ASWB exam preparation. Clear platform guidelines and content standards." />
        <meta name="twitter:image" content="https://www.socialworktestprepacademy.com/images/default-og-image.png" />
        {/* Clean canonical — NOT window.location.href, which folds UTM/ref into
            the canonical and self-competes every campaign link (SEO audit). */}
        <link rel="canonical" href="https://www.socialworktestprepacademy.com/disclosures" />
      </Helmet>
      <div className="new-home-container">
        <div className="new-home-content">
          <div className="new-home-inner">
            <div className="disclosures">
              <h1 className="text-2xl sm:text-3xl font-bold mb-4 text-center text-neutral-900">Disclosure Statement for Social Work Test Prep Academy</h1>
              <p className="text-base sm:text-lg mb-6 text-center text-neutral-600">Last updated: Thursday September 19th 2024</p>

              <h2 className="text-xl font-semibold mb-3 text-neutral-900">1. Purpose of Service</h2>
              <p className="mb-4 text-neutral-700">
                Social Work Test Prep Academy provides test preparation materials and services for the Association of Social Work Boards (ASWB) Licensed Clinical Social Worker (LCSW) examination. Our content is designed to assist users in their exam preparation but does not guarantee success on the actual ASWB LCSW exam.
              </p>

              <h2 className="text-xl font-semibold mb-3 text-neutral-900">2. Content Disclaimer</h2>
              <p className="mb-4 text-neutral-700">
                The content provided through our service is for educational and preparatory purposes only. While we strive for accuracy and relevance, we do not guarantee that our materials cover all possible questions or topics that may appear on the official ASWB LCSW exam.
              </p>

              <h2 className="text-xl font-semibold mb-3 text-neutral-900">3. Not Affiliated with ASWB</h2>
              <p className="mb-4 text-neutral-700">
                Social Work Test Prep Academy is not affiliated with, endorsed by, or connected to the Association of Social Work Boards (ASWB) or any official licensing body. Our service is an independent resource for exam preparation.
              </p>

              <h2 className="text-xl font-semibold mb-3 text-neutral-900">4. Expert Contributors</h2>
              <p className="mb-4 text-neutral-700">
                Our quiz questions and materials are curated by professionals with extensive experience in the field of social work. However, individual contributors&apos; opinions may not represent official exam content or standards.
              </p>

              <h2 className="text-xl font-semibold mb-3 text-neutral-900">5. User Responsibility</h2>
              <p className="mb-4 text-neutral-700">
                Users are responsible for verifying the licensing requirements in their specific jurisdiction and ensuring they meet all necessary qualifications to sit for the ASWB LCSW exam.
              </p>

              <h2 className="text-xl font-semibold mb-3 text-neutral-900">6. No Guarantee of Results</h2>
              <p className="mb-4 text-neutral-700">
                While we believe our services can significantly aid in exam preparation, we cannot and do not guarantee that use of our materials will result in passing the ASWB LCSW exam.
              </p>

              <h2 className="text-xl font-semibold mb-3 text-neutral-900">7. Beta Version Disclosure</h2>
              <p className="mb-4 text-neutral-700">
                Our current offering is in beta testing phase. Users should be aware that features, content, and functionality may change as we continue to develop and refine our service based on user feedback and testing results.
              </p>

              <h2 className="text-xl font-semibold mb-3 text-neutral-900">8. Data Usage</h2>
              <p className="mb-4 text-neutral-700">
                User quiz results and progress data are collected and used to improve our service and provide personalized feedback. Please refer to our Privacy Policy for more detailed information on data collection and usage.
              </p>

              <h2 className="text-xl font-semibold mb-3 text-neutral-900">9. Third-Party Links</h2>
              <p className="mb-4 text-neutral-700">
                Our service may contain links to third-party websites or resources. We are not responsible for the content or practices of these external sites.
              </p>

              <h2 className="text-xl font-semibold mb-3 text-neutral-900">10. Intellectual Property</h2>
              <p className="mb-4 text-neutral-700">
                All content provided through Social Work Test Prep Academy, including but not limited to quiz questions, explanations, and study materials, is protected by copyright and other intellectual property laws. Reproduction or distribution without explicit permission is prohibited.
              </p>

              <h2 className="text-xl font-semibold mb-3 text-neutral-900">11. Changes to Service</h2>
              <p className="mb-4 text-neutral-700">
                We reserve the right to modify, suspend, or discontinue any part of our service at any time without notice.
              </p>

              <h2 className="text-xl font-semibold mb-3 text-neutral-900">12. Contact Information</h2>
              <p className="mb-4 text-neutral-700">
                If you have any questions about this disclosure statement or our services, please contact us at: support@socialworktestprepacademy.com
              </p>

              <p className="mt-6 text-neutral-700">
                By using Social Work Test Prep Academy, you acknowledge that you have read, understood,
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Disclosures;
